<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <SectionWrapper class="whiteframe shadowframe modal-container">
          <button class="modal-close-button" @click="$emit('cancel')">
            <Icon type="x" />
          </button>

          <SectionHeader class="modal-header">
            <slot name="header"></slot>
          </SectionHeader>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </SectionWrapper>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  overflow: auto;
  max-width: 500px;
  max-height: 100%;

  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.33);
  border: 1px solid #759add;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  position: relative;

  @media (max-width: 500px) {
    border-radius: 0;
    padding: 1em 0;
  }
}

.modal-body {
  margin: 20px 0;
}

.modal-close-button {
  position: absolute;
  top: 10px;
  right: 5px;
}

/*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
